import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import objectPath from "object-path";
import { shallowEqual, useSelector } from "react-redux";
import SVG from "react-inlinesvg";

import { toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Topbar } from "./Topbar";
import { HeaderMenuWrapper } from "./header-menu/HeaderMenuWrapper";
import { SearchDropdown } from "../extras/dropdowns/search/SearchDropdown";

export function Header() {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      ),
    };
  }, [uiService]);

  const { isAuthorized } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null,
    }),
    shallowEqual
  );

  return (
    <>
      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        <div
          className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-between`}
        >
          {/* begin::Left */}
          <div className="d-flex align-items-stretch mr-3">
            {/* begin::Header Logo */}
            <div className="header-logo">
              <Link to="/">
                <img
                  className="logo-default max-h-78px"
                  alt="Logo"
                  src={toAbsoluteUrl(
                    "/media/logos/MPKN-Horizontal_Logo-RGB-Inverse_Large-1000.png"
                  )}
                />
                <img
                  className="logo-sticky max-h-78px"
                  alt="Logo"
                  src={toAbsoluteUrl(
                    "/media/logos/MPKN-Horizontal_Logo-RGB-Inverse_Large-1000.png"
                  )}
                />
              </Link>
            </div>
            {/* end::Header Logo */}
            {layoutProps.menuHeaderDisplay && <HeaderMenuWrapper />}
          </div>
          {/* end::Left */}

          {/*begin::Topbar*/}

          {isAuthorized ? (
            <Topbar />
          ) : (
            <div className="topbar">
              <SearchDropdown />
              <div className="topbar-item">
                <Link
                  to="/auth/login"
                  style={{
                    color: "white",
                    fontFamily: "AnonymousPro-Bold",
                    fontSize: 17,
                  }}
                >
                  <span className="navi-icon mr-2">
                    <span className="svg-icon svg-icon-login">
                      <SVG
                        style={{ fill: "white" }}
                        src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                      ></SVG>{" "}
                    </span>
                  </span>
                  Најави се
                </Link>
              </div>
            </div>
          )}
          {/*end::Topbar*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header*/}
    </>
  );
}
